import { Form, Formik } from "formik";
import * as Yup from "yup";
import FilledCaretRight from "static/images/FilledRightCaret.svg";

// components
import { TextInput } from "components/DesignSystem/TextInput/TextInput";
import { Button } from "components/DesignSystem/Button/Button";
import { FileInput } from "components/FileInput/FileInput";

const validationSchema = Yup.object({
  name: Yup.string().required("Company name is required"),
  website: Yup.string()
    .url("Enter a valid URL")
    .required("Website is required"),
  linkedin: Yup.string()
    .url("Enter a valid URL")
    .required("LinkedIn is required"),
  shortDescription: Yup.string().required("Description is required"),
  icon: Yup.mixed().required("Logo is required"),
});

const CompanyInformation = ({
  goBack,
  setPerkData,
  handleChange,
  setPreviewImage,
  setCurrentState,
  perkData,
}) => {
  const onDrop = ([acceptedFile]) => {
    setPreviewImage(
      Object.assign(acceptedFile, {
        preview: URL.createObjectURL(acceptedFile),
      })
    );
  };

  const storeData = ({ icon, ...values }) => {
    setPerkData((perkData) => ({ ...perkData, ...values, file: icon }));
    setCurrentState(1);
  };

  return (
    <>
      <span className="perkRightContainerHeader">Company Information</span>
      <Formik
        onSubmit={storeData}
        validationSchema={validationSchema}
        initialValues={{
          name: perkData.name,
          website: perkData.website,
          linkedin: perkData.linkedin,
          shortDescription: perkData.shortDescription,
          icon: perkData.file || null,
        }}
      >
        {({ setFieldValue }) => (
          <Form className="w-100 newPerkForm" onChange={handleChange}>
            <div className="t-flex t-flex-col t-gap-3">
              <TextInput
                placeholder="The name of your company"
                name="name"
                label="Company"
                required
                showErrorOnceTouched
              />
              <FileInput
                name="icon"
                withForm
                required
                label="Logo"
                accept={{
                  "image/png": [".png", ".jpg", ".jpeg", ".webp"],
                }}
                onDrop={onDrop}
                onDelete={() => setFieldValue("icon", null)}
              />

              <TextInput
                type="url"
                placeholder="Your company website"
                name="website"
                label="Website"
                required
                showErrorOnceTouched
              />

              <TextInput
                type="url"
                placeholder="Your LinkedIn Link"
                name="linkedin"
                label="LinkedIn"
                required
                showErrorOnceTouched
              />

              <TextInput
                maxLength="60"
                placeholder="One sentence description of company/product"
                name="shortDescription"
                label="Short Description"
                required
                showErrorOnceTouched
              />
            </div>
            <div className="t-flex t-justify-between t-w-full">
              <Button onClick={goBack} type="button">
                Cancel
              </Button>
              <Button customType="ghost_icon" type="submit">
                <img src={FilledCaretRight} alt="CaretRight" />
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default CompanyInformation;
